import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { CaseModel } from '@app/ps/models/case.model';

@Component({
  selector: 'form-expropriation-compensation-payment',
  templateUrl: './form-expropriation-compensation-payment.component.html',
})
export class FormExpropriationCompensationPaymentComponent implements OnInit {
  @Output()
  callbackRegister = new EventEmitter();
  @Input() data: CaseModel;

  constructor() {
    this.isValid = this.isValid.bind(this);
  }

  ngOnInit() {
    this.data.expropriationCompensationPaymentDate = new Date();
    this.callbackRegister.emit({
      isValid: this.isValid,
    });
  }

  isValid() {
    return !!this.data.expropriationCompensationPaymentDate;
  }
}

